<app-page-wrapper [title]="'classifications' | i18n">
  <ng-container nav-action>
    <app-gloss-button [options]="addClassificationButton"></app-gloss-button>
  </ng-container>

  <div
    id="classifications-table"
    class="tw-bg-dt-neutral-200 tw-w-[50%] tw-overflow-hidden tw-rounded-2xl tw-shadow-account-detail tw-p-3 sm:tw-shadow-none sm:gutter-bleed-x sm:tw-px-0 sm:tw-pt-0"
  >
    @if (!(this.table.selectedClassification() && this.deviceDetectorService.isMobile())) {
      <div class="tw-mb-2 tw-px-1 sm:tw-px-4 tw-flex tw-justify-end tw-relative xs:tw-mt-4 tw-z-10">
        <input
          type="text"
          class="tw-w-1/3 sm:tw-w-1/2 tw-pl-3 tw-pr-8 tw-py-2 tw-border tw-border-dt-border-primary tw-rounded-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-teal-500"
          placeholder="{{ 'searchClassifications' | i18n }}"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange($event)"
        />
        <div class="search-bar-icon tw-mr-3 sm:tw-right-2 sm:tw-p-2">
          <icon [name]="'magnifier'" [size]="5"></icon>
        </div>
      </div>
    }
    <app-ag-grid-table
      [options]="table?.options"
      [data]="table?.data()"
      [hasBottomBorder]="true"
      [hasTopBorder]="true"
      customGridClass="ag-transparent-bg ag-card-rows"
    ></app-ag-grid-table>
  </div>

  @if (this.table.selectedClassification()) {
    <div class="details-wrapper">
      <app-classifications-details
        [selectedClassificationId]="this.table.selectedClassification().id"
        (onBackClicked)="cleanSelectedClassification()"
      ></app-classifications-details>
    </div>
  }
</app-page-wrapper>
